const textButtonStyles = {
  button: {
    minWidth: 50,
  },
}

export default textButtonStyles
